export default __webpack_public_path__ + "static/media/acceso-camara-windows-2.a00a678c.svg";